<template>
  <div class="bienes-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :rubro="rubro"
          :personal="personal"
          :incluirBienesPersonal="incluirBienesPersonal"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Bienes">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="bienes" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(cotizacion)="data">
              {{ data.item.cotizacion | moneda }}
            </template>
            <template v-slot:cell(enRevision)="data">
              {{ data.item.enRevision ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Datos del Bien</b-dropdown-item>
                <b-dropdown-item v-if="data.item.personalId == 0" 
                    @click.stop="asignarBienPersonal(data.item)">
                  <i class="fa fa-edit"></i>Entregar a Personal</b-dropdown-item>
                <b-dropdown-item v-if="data.item.personalId != 0" 
                    @click.stop="devolverBienPersonal(data.item)">
                  <i class="fa fa-edit"></i>Devolver Bien</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregarBien">
            <i class="fa fa-plus"></i>Agregar Bien</b-dropdown-item>

          <b-dropdown-item @click.stop="agregarCelular">
            <i class="fa fa-plus"></i>Agregar Celular</b-dropdown-item>

          <b-dropdown-item @click.stop="agregarComputadora">
            <i class="fa fa-plus"></i>Agregar Computadora</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>    

    <b-modal ref="asignacionModal"
        title="Entrega de Bienes"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-asignacion
        @registrarAsignacion="registrarAsignacion"
        @cancelarAsignacion="cancelarAsignacion">
      </app-asignacion>  
    </b-modal>

    <b-modal ref="devolucionModal"
        title="Devolución de Bienes"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-devolucion-observaciones
        @save="registrarDevolucion"
        @cancelar="cancelarDevolucion">
      </app-devolucion-observaciones>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Asignacion from  './Asignacion.vue';
import DevolucionObservaciones from  '../shared/observacionesModal.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import Filtro from './listFiltro.vue';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bienes/getField',
  mutationType: 'bienes/updateField',
});

export default {
  name: 'BienesList',
  components: {
    appAsignacion: Asignacion,
    appDevolucionObservaciones: DevolucionObservaciones,
    appFiltro: Filtro,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'codigo',
          label: 'Código'
        },
        {
          key: 'nombre',
        },
        {
          key: 'rubro',
        },
        {
          key: 'cotizacion',
          class: 'text-right'
        },
        {
          key: 'personal',
        },
        {
          key: 'enRevision',
          label: 'Revisión',
          class: 'text-center'
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
      bienId: 0
    }
  },
  computed: {
    ...mapFields([
      'bienes',
      'nombre',
      'rubro',
      'personal',
      'incluirBienesPersonal',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.rubro = filtro.rubro;
      this.personal = filtro.personal;
      this.incluirBienesPersonal = filtro.incluirBienesPersonal;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('bienes/getBienes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      switch (item.tipoBien) {
        case 1:
          this.$router.push({ name: 'BienData', 
                              params: { id: item.id }})
          break;

        case 2:
          this.$router.push({ name: 'ComputadoraData', 
                              params: { id: item.id }})
          break;

        case 3:
          this.$router.push({ name: 'CelularData', 
                              params: { id: item.id }})
          break;
      }
    },
    editar (item) {
      switch (item.tipoBien) {
        case 1:
          this.$router.push({ name: 'BienEdit', 
                              params: { id: item.id }})
          break;

        case 2:
          this.$router.push({ name: 'ComputadoraEdit', 
                              params: { id: item.id }})
          break;

        case 3:
          this.$router.push({ name: 'CelularEdit', 
                              params: { id: item.id }})
          break;
      }
    },
    agregarBien () {
      this.$router.push({ name: 'BienAdd' })
    },
    agregarComputadora () {
      this.$router.push({ name: 'ComputadoraAdd' })
    },
    agregarCelular () {
      this.$router.push({ name: 'CelularAdd' })
    },
    asignarBienPersonal(item) {
      this.bienId = item.id;
      this.$refs.asignacionModal.show();
    },
    registrarAsignacion(params) {
      params.bienId = this.bienId;

      this.$refs.asignacionModal.hide();
      
      this.showSpinner();
      this.$store.dispatch('bienes/entregaPersonal', params)
        .then(() => this.showModalMsj('La entrega se registró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarAsignacion() {
      this.$refs.asignacionModal.hide();
    },
    devolverBienPersonal(item) {
      this.bienId = item.id;
      this.$refs.devolucionModal.show();
    },
    registrarDevolucion(params) {
      params.bienId = this.bienId;

      this.$refs.devolucionModal.hide();
      
      this.showSpinner();
      this.$store.dispatch('bienes/devolucionPersonal', params)
        .then(() => this.showModalMsj('La devolución se registró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());      
    },
    cancelarDevolucion() {
      this.$refs.devolucionModal.hide();
    }
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
  .bienes-list .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .bienes-list .registro table td[aria-colindex="2"] {
    width: calc(30% - 60px);
  }
  .bienes-list .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .bienes-list .registro table td[aria-colindex="4"] {
    width: 15%;
  }
  .bienes-list .registro table td[aria-colindex="5"] {
    width: 15%;
  }
  .bienes-list .registro table td[aria-colindex="6"] {
    width: 10%;
  }
  .bienes-list .registro table td[aria-colindex="7"] {
    width: 60px;
  }
</style>
